export default "/images/0c26a510fb00fca2e58401598a373a14.jpg";